'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
		return Number.isNaN;
	}
	return implementation;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-nan/polyfill.js
 ** module id = 486
 ** module chunks = 0
 **/